import { useDataSubmit } from 'Simple/Data'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return async function onClick(value) {
    await submit({ type: 'mark-all-as-read' })
  }
}
